import createTemplate from "../../utils/createTemplate";

export const dotContainerTemplate = (area) => createTemplate(`
    <div class="dots-container" style="${area.style}">
        <div class="product-dot-cont">
            <div class="product-dot">
                <div class="details-container hidden desktop">
                    <div class="description-container">
                        <p class="dots-container__title">${area.title}</p>
                             <img src="${area.thumbnail}" class="dots-container__image" />
                        <p class="dots-container__price">${area.price}</p>
                    </div>
                    <div class="info-container">
                        <a class="dots-container__link"  href="${area.href}" target="_blank">"${area.buyCaption}"</a>
                    </div>
                </div>
                <div class="details-container hidden mobile">
                    <div class="description-container">
                        <img src="${area.thumbnail}" class="dots-container__image" />
                        <p class="dots-container__title">${area.title}</p>
                    </div>
                    <div class="info-container">
                        <p class="dots-container__price">${area.price}</p>
                        <a class="dots-container__link"  href="${area.href}" target="_blank">"${area.buyCaption}"</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
`).getElement();
